import React from 'react';
import { Layout, Space, Avatar, Dropdown } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '../../auth/authcontext';

const { Header, Content, Footer } = Layout;

const UnauthorizedLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const { displayName, logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    const userMenu = (
        <Dropdown
            menu={{
                items: [
                    {
                        key: 'logout',
                        label: (
                            <span onClick={handleLogout}>
                                <LogoutOutlined /> Logout
                            </span>
                        ),
                    },
                ],
            }}
        >
            <Space style={{ cursor: 'pointer', color: 'white' }}>
                <Avatar icon={<UserOutlined />} />
                {displayName || 'User'}
            </Space>
        </Dropdown>
    );

    const headerBackgroundColor = 'var(--color-primary)';
    const footerBackgroundColor = 'var(--color-secondary)';

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Header
                style={{
                    padding: '0 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: headerBackgroundColor,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Space align="center">
                    <div
                        style={{
                            fontSize: '1.8em',
                            fontWeight: 600,
                            color: 'white',
                            fontFamily: 'sans-serif',
                            marginRight: '10px',
                        }}
                    >
                        MTO MenuBook
                    </div>
                </Space>
                {userMenu}
            </Header>

            <Content
                style={{
                    padding: '40px 52px',
                    background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {children}
            </Content>

            <Footer
                style={{
                    textAlign: 'center',
                    background: footerBackgroundColor,
                    borderTop: '1px solid #e8e8e8',
                    padding: '5px 0',
                }}
            >
                Designed by MTO Dev © {new Date().getFullYear()}
            </Footer>
        </Layout>
    );
};

export default UnauthorizedLayout;